import React, { useState } from "react";
import "./../../../../assets/css/Dashboard/ServicesKanban.scss";
import useTitanApp from "../../../../hooks/useTitanApp";
import { Checkbox } from "@mui/material";
function SmsStages({
  service,
  view,
  smsQueue,
  setCurrentSmsQueue,
  interventionQueue,
  setCurrentInterventionQueue,
}) {
  const { appState } = useTitanApp();
  const { currentPharmacy } = appState;

  const addServiceForSms = (event, addedService, view) => {
    const { checked } = event?.target || {};

    if (checked) {
      const obj = {
        patientID: addedService?.patientId,
        patientName: addedService?.patientName,
        pharmacyID: addedService?.pharmacyID,
        message: "",
        clinicalServiceID: addedService?._id,
        pharmacyName: currentPharmacy?.teamPharmacyName,
        ods: "",
      };

      setCurrentSmsQueue((prevQueue) => {
        const newArrSmsQueue = [...prevQueue, obj];
        return newArrSmsQueue;
      });

      setCurrentInterventionQueue((prevQueue) => {
        const newArrInterventionQueue = [...prevQueue, addedService?._id];
        return newArrInterventionQueue;
      });
    } else {
      setCurrentSmsQueue((prevQueue) => {
        const newArraySmsQueue = prevQueue.filter(
          (obj) => obj?.clinicalServiceID !== addedService?._id
        );

        return newArraySmsQueue;
      });

      setCurrentInterventionQueue((prevQueue) => {
        const newArrayInterventionQueue = prevQueue.filter(
          (id) => id !== addedService?._id
        );

        return newArrayInterventionQueue;
      });
    }
  };

  return (
    <div>
      <Checkbox
        edge="start"
        tabIndex={-1}
        checked={smsQueue.some(
          (obj) => obj?.clinicalServiceID === service?._id
        )}
        onClick={(e) => {
          e.stopPropagation();
          addServiceForSms(e, service, view);
        }}
        size="small"
        disableRipple
      />
    </div>
  );
}
export default React.memo(SmsStages);
